import Vue from 'vue'
import Vuex from 'vuex'

import { context } from './modules/context'
import { profile } from './modules/profile'
import { form } from './modules/form'
import { event } from './modules/event'

Vue.use(Vuex)


const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    context,
    profile,
    form,
    event,
  }
})

// Load the user data from local store
store.dispatch('profile/loadUser')

export default store
